import {useTheme} from '@mui/material';
import type {ManifestationStatus} from 'services/metadata/types';
import {getManifestationStatusColorName} from '../functions';

export const useManifestationStatusColor = (
  status: ManifestationStatus,
): string => {
  const {status: statusColors} = useTheme();
  return statusColors[getManifestationStatusColorName(status)];
};
